import {
  GETCURRENCYMASTERLIST_SUCCESS,
  GETCURRENCYMASTERLIST_FAILED,
  RESET_GETCURRENCYMASTERLIST,
  LOADING_GETCURRENCYMASTERLIST,
  NETWORK_ERROR_GETCURRENCYMASTERLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETCURRENCYMASTERLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETCURRENCYMASTERLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETCURRENCYMASTERLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETCURRENCYMASTERLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETCURRENCYMASTERLIST:
      return (state = initialState);
    default:
      return state;
  }
};
